const hostname = window.location.hostname;

const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
const isDev = hostname === 'tutores.programassociales-dev.com';
const isProduction = !isLocalhost && !isDev;

const ENDPOINTAPI = !isLocalhost;
const CONFIGDEV = null;
const CONFIGPROD = null;
const CONFIGFIREBASE = isProduction ? CONFIGPROD : CONFIGDEV;
const RECAPTCHA_SITE_KEY = (() => {
  if (isLocalhost) {
    return '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
  } else if (isDev) {
    return '6LfDcpAsAAAAABfwbGRQFOcH-P-S4rW_xNeCrkL8';
  } else {
    return '6LeeycEsAAAAACc71n3fNaXzGPJtBxCGkCS_LQLC';
  }
})();

const MAINTENANCE_MODE = (() => {
  if (isLocalhost) return false;
  if (isDev) return false;
  return false; 
})();

const environment = {
  production: isProduction,
  development: isDev,
  local: isLocalhost,
  enableLog: !isProduction,
  apiEndPoint: (ENDPOINTAPI) ? '/services/' : 'http://localhost:8085/services/',
  firebaseConfigEnv: CONFIGFIREBASE,
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,
  maintenanceMode: MAINTENANCE_MODE,
};

export default { environment };